'use strict';
var sw = require('js/lib/sw');

/* Social intents tracking */
module.exports = function modelShareIntentTrack($modelShareType, productSpin, $service, data) {
  if (sw.data.rid) {
    data = data || {};
    data.spin = productSpin;
    data.service = $service;
    data.rid = sw.data.rid;
    sw.track($modelShareType, data);
  }
};
